/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Member, useAppSettings, useSpringBigStore } from '@springbig/shared';
import { Box, Center, HStack, Skeleton, VStack, useColorMode } from 'native-base';

import SliderBar, { DefaultValuesPointsProps } from '~/shared/RangeBar';
import { Caption } from '~/shared/Typography';
import { useGeneralStyles, useRewardsStyles } from '~/shared/styles';
import Pressable from '~/shared/Pressable';

type RewardHeaderProps = {
    member?: Member | null;
    setShowLoyaltyAlert: (show: boolean) => void;
    rewardMaxAmount?: number
    rewardCheckPoints: DefaultValuesPointsProps[]
}

const RewardHeader = ({ member, rewardCheckPoints, rewardMaxAmount, setShowLoyaltyAlert }: RewardHeaderProps) => {

    const { hasCustomBackground, background } = useAppSettings();
    const { colorMode } = useColorMode();
    const { text } = useRewardsStyles();
    const gStyle = useGeneralStyles();
    const {
        style: { rewards: { rewardHeader = {}, rewardpoints = {} } = {} } = {}
    } = useAppSettings();

    return (
        <Box
            width='100%'
            px={4}
            background={hasCustomBackground ? `url(${colorMode === 'light' ? background?.light : background?.dark})` : gStyle.screen_background}
            pb={4}
            {...rewardHeader}
            mb={5}
        >
            <Center alignItems='center' >
                <Caption
                    fontSize={'3xl'}
                    color={text}
                    {...rewardpoints}
                >{member?.balance || '0'}</Caption>
                <Caption
                    fontSize={'xl'}
                    text='rewards.available_points'
                    color={text}
                />
                {member && !member.allowed_loyalty && (
                    <Pressable onPress={() => setShowLoyaltyAlert(true)}>
                        <Caption
                            text='rewards.click_here_to_earn'
                            color={gStyle.link}
                        />
                    </Pressable>
                )}
                <Center w={'100%'} alignItems='center'>
                    {
                        member && <SliderBar
                            maxValue={rewardMaxAmount}
                            valuePoints={rewardCheckPoints}
                            defaultValue={member.balance}
                            dots={true}
                        />
                    }
                </Center>
            </Center>
        </Box>
    );

};

export const RewardHeaderSkeleton = () => {
    return (
        <VStack w='100%' alignSelf={'center'} alignItems={'center'} mt={10}>
            <Skeleton  w={20} h={30} mb={4} borderRadius={4} />
            <Skeleton  w={'15rem'} h={4} mb={4} borderRadius={4} />
            <HStack alignItems={'center'} alignSelf={'center'} w='60%' >
                <Skeleton  h={3} w={3} rounded={'full'}  borderRadius={5}/>
                <Skeleton  h={1.5}  />
                <Skeleton  h={3} w={3} rounded={'full'}  borderRadius={5}/>
            </HStack>
        </VStack>
    );
};

export default RewardHeader;
